import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { BackgroundLogin, GrologLogo } from '../../asset';
import { ROUTES } from '../../constant/routeConstant';
import { useDispatch, useSelector } from 'react-redux';
import { setIsCompletionAcc, setIsWaitingApprove, setToken } from '../../store/reducer/authentication.reducer';
import { BASE_URL, GROCHAT_URL, GROLOG_URL, REDIRECT_URI_PWA } from '../../constant/apiConstant';
import * as LoginServices from '../../service/loginServices'
import { setGrologAccInfo, setStatusInvitation } from "../../store/reducer/page.reducer";
import { SHA256 } from 'crypto-js';

const LoginInvitation = () => {
  const [searchParams] = useSearchParams()
  const invitationCode = searchParams.get("invitation_code")
  const navigate = useNavigate();
  const dispatch = useDispatch();
const {statusInvitation} = useSelector((state)=>state.page)

  const handleLogin = async () => {
    const length = 6;
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let randomString = "";

    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * chars.length);
      randomString += chars.charAt(randomIndex);
    }
    const newRandomString = randomString;
    const hash = SHA256(newRandomString).toString();
    localStorage.setItem("random_string", newRandomString);
    localStorage.setItem("first_req_id", hash);
    if (randomString && hash) {
      const { status, internal_token } = await LoginServices.getInternalToken();
      if (status) {
        getNewWindow(internal_token, hash);
      }
    }
  }
  
  const getNewWindow = (token, request_id) => {
    const link = `${GROCHAT_URL}/validate?token=${token}&successURI=${process.env.REACT_APP_GROLOG_URL}${ROUTES.LOGIN_INVITATION_SUCCESS}&resourceID=log&resourceName=grolog&cancel=${REDIRECT_URI_PWA}${ROUTES.LOGIN_INVITATION_FAILED}&invitationCode=${invitationCode}&userType=R&requestID=${request_id}`
    console.log("link", link);
    window.open(link, "", "width=600,height=1000,left=200,top=200");
  }
  
  useEffect(() => {
    loginPWA();
    
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    
    if(statusInvitation){
      console.log("masuk sini");
      navigate(ROUTES.INDEX)
    }
  }, [statusInvitation]);

  const loginPWA = () => {
    const loginTimer = setInterval(() => {
      if (localStorage.getItem("invitation") !== null) {
        localStorage.removeItem("invitation");
        localStorage.removeItem("auth_code");
        localStorage.removeItem("request_id");
        localStorage.removeItem("first_req_id");
        localStorage.removeItem("random_string");
        navigate(ROUTES.INDEX);
      }
    }, 2000);
    return () => clearInterval(loginTimer);
  }

  // const getToken = async (auth_code, request_id, code_verifier) => {
  //   const body = { auth_code, request_id, code_verifier };
  //   const { status, data } = await LoginServices.authPWA(body);
  //   console.log("data", data);
  //   if (status) {
  //     dispatch(setToken(data?.token));
  //     dispatch(setIsCompletionAcc(data?.is_completion_account));
  //     dispatch(setIsWaitingApprove(data?.is_waiting_approve));
  //     dispatch(setGrologAccInfo(data?.grochat_account_information))
  //     // if(data?.is_completion_account && data?.is_invitation){
  //     //   navigate(ROUTES.COMPLETION)
  //     // }else if(data?.is_completion_account && !data?.is_invitation){
  //     //   navigate(ROUTES.COMPLETION_DATA)
  //     // }else{
  //     // navigate(ROUTES.SELECT_PORTAL);
  //     // }
      
  //     navigate(ROUTES.INDEX);
  //   }

  //   localStorage.removeItem("auth_code");
  //   localStorage.removeItem("request_id");
  //   localStorage.removeItem("first_req_id");
  //   localStorage.removeItem("random_string");
  // }

  return (
    <div className=' flex w-full h-screen'>
      <div
      className='w-4/6'
      style={{
        backgroundImage: `url(${BackgroundLogin})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
      ></div>
      <div className=' w-2/6 p-20 flex flex-col justify-center items-center'>
        <img src={GrologLogo} alt='grolog-logo' className=' w-60 p-5 mx-auto' />
        <div className=' mt-5 text-center'>
          <p className=' font-sans-bold text-black-700 leading-8 text-lg'> Your Logistic Solution Partner </p>
        </div>
        <button
          onClick={handleLogin}
          className=' mt-8 bg-red-100 font-sans-medium w-full text-sm h-8 text-white-100 rounded-md'>
          <p className=' font-sans text-white-600 leading-8 text-lg'> Connect with Grochat Account </p>
        </button>
      </div>
    </div>
  );
}

export default LoginInvitation;
